import React from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import useLogin from "../../hooks/useLogin";
import Avatar from "./Avatar";
import Imagen from '../../assets/images/logo-mini.svg';
import { ASSETS_URL } from "./utils/urls";

export default function Navbar() {
  const { logout, user, user_rol, imagen } = useLogin();
  const toggleOffcanvas = () => {
    document.querySelector(".sidebar-offcanvas").classList.toggle("active");
  };

  const carpetaDeFotos =
    (user_rol === "proveedor" && "PROVEEDOR") ||
    (user_rol === "cliente" && "CLIENTE") ||
    null;
  const fotoDelUsuario =
    carpetaDeFotos && imagen
      ? `${ASSETS_URL}images/fotos/${carpetaDeFotos}/${imagen}`
      : null;

  const closeSession = () => {
    logout();
  };

  return (
    <nav className="navbar p-0 fixed-top d-flex flex-row">
      <div className="navbar-brand-wrapper d-flex d-lg-none align-items-center justify-content-center">
        <Link className="navbar-brand brand-logo-mini" to="/">
          <img src={Imagen} alt="logo" />
        </Link>
      </div>
      <div className="navbar-menu-wrapper flex-grow d-flex align-items-stretch">
        <button
          className="navbar-toggler align-self-center"
          type="button"
          onClick={() => document.body.classList.toggle("sidebar-icon-only")}
        >
          <span className="mdi mdi-menu"></span>
        </button>
        <ul className="navbar-nav navbar-nav-right">
          <Dropdown alignright="true" as="li" className="nav-item">
            <Dropdown.Toggle
              as="a"
              className="nav-link cursor-pointer no-caret"
            >
              <div className="navbar-profile">
                <Avatar nombre={user} src={fotoDelUsuario} tamano={32} />
                <p
                  className="mb-0 d-none d-sm-block navbar-profile-name"
                  style={{ textTransform: "capitalize" }}
                >
                  {user_rol}
                </p>
                <i className="mdi mdi-menu-down d-none d-sm-block"></i>
              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu className="navbar-dropdown preview-list navbar-profile-dropdown-menu">
              <Dropdown.Divider />
              <Dropdown.Item href="/perfil" className="preview-item px-4">
                <div className="preview-thumbnail">
                  <div className="preview-icon preview-icon-menta rounded-circle">
                    <i className="mdi mdi-account-circle text-success"></i>
                  </div>
                </div>
                <div className="preview-item-content">
                  <p className="preview-subject mb-1">
                    Perfil
                  </p>
                </div>
              </Dropdown.Item>
              <Dropdown.Divider />
              <div onClick={closeSession} className="preview-item align-items-center px-4" role={"button"}>
                <div className="preview-thumbnail">
                  <div className="preview-icon preview-icon-menta rounded-circle">
                    <i className="mdi mdi-logout text-danger"></i>
                  </div>
                </div>
                <div className="preview-item-content">
                  <p className="preview-subject mb-1">
                    Cerrar sesión
                  </p>
                </div>
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </ul>
        <button
          className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
          type="button"
          onClick={toggleOffcanvas}
        >
          <span className="mdi mdi-format-line-spacing"></span>
        </button>
      </div>
    </nav>
  );
}
